import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const updateCollabStatus = createApi(`UpdateCollabStatusSlice`, "POST");

const UpdateCollabStatusSlice = createSlice({
  name: 'UpdateCollabStatusSlice',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateCollabStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCollabStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateCollabStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default UpdateCollabStatusSlice.reducer;
